'use client';

import { handleRequest } from "./common";
import { websocketRequest } from "./requests";

export async function getMessages(roomId: string) {
  const data = await handleRequest(`/chatapp/rooms/${roomId}/messages`, 'GET');
  return data || [];
}

export async function getMessagesWebsocketURL(roomId: string) {
  const url = websocketRequest(`/chatapp/rooms/${roomId}/messages/ws`);
  return url;
}